module.exports = __webpack_public_path__ + "img/arrow.2c917068.svg";